import { render, staticRenderFns } from "./AssociarDetalhes.vue?vue&type=template&id=6ee03203"
import script from "./AssociarDetalhes.vue?vue&type=script&lang=js"
export * from "./AssociarDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports